module.exports = __webpack_public_path__ + "static/genify-logo-white-f8017b2ef54bd57d4a9f898215adddab.webp";